<template>
	<div style="width: 100%">
		<iframe
			src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2595.8018142328665!2d8.704345951214083!3d49.412653469372536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f07.1!3m3!1m2!1s0x4797c191135909d9%3A0x8eca250334cb5aa9!2sPraxis%20f%C3%BCr%20Psychotherapie%20Amrei%20Schaal!5e0!3m2!1sen!2sde!4v1662980629458!5m2!1sen!2sde"
			width="100%"
			style="border: 0"
			allowfullscreen=""
			loading="lazy"
			referrerpolicy="no-referrer-when-downgrade"
		></iframe>
	</div>
</template>

<script>

export default {
	name: "GoogleMap",
};
</script>

<style lang="scss" scoped>
	iframe {
		height: 600px !important;
	}
</style>

